import React, { useEffect, useState } from 'react';
import { Redirect, Route, RouteComponentProps } from 'react-router-dom';
import { getUserInfo } from 'utils/helpers';
import { IRole } from 'interfaces';

interface IStaticContext {
  statusCode?: number;
}

interface IRouter {
  path: string;
  exact?: boolean;
  component?:
    | React.ComponentType<RouteComponentProps<any, IStaticContext, unknown>>
    | React.ComponentType<any>
    | undefined;
  permissions?: IRole[];
  render?: any;
}

export const PermissionRoute = ({ permissions, path, exact = false, component, render }: IRouter) => {
  const [authChecked, setAuthChecked] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    setIsAuthenticated(!!token);
    setAuthChecked(true);
  }, []);

  if (!authChecked) {
    return null;
  }

  const role: IRole = getUserInfo('role');

  if (permissions && !isAuthenticated && path !== '/sign-in') {
    const currentPath = window.location.pathname;
    return <Redirect to={`/sign-in?redirectTo=${encodeURIComponent(currentPath)}`} />;
  }

  if (permissions && isAuthenticated && !permissions.includes(role)) {
    return null;
  }

  return <Route path={path} exact={exact} component={component} render={render} />;
};
